export default function () {
  return {
    banlists: [],
    banlistsCurrentPage: 1,
    banlistsLastPage: 1,
    banlistsPerPage: 0,
    banlistsTotal: 0,
    banlistsLoading: false,
    indexPage: null,
    search: ''
  }
}
